document.addEventListener('DOMContentLoaded', function() {
  const cardItems = document.querySelectorAll('.customer-story-card-flex-item');
  const cardInners = document.querySelectorAll('.customer-story-card');
  let expandedIndex = 0; // Default to first card

  function setExpanded(index) {
    console.log('Setting expanded index to:', index);
    cardItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add('expanded');
      } else {
        item.classList.remove('expanded');
      }
    });
    expandedIndex = index;
  }
  
  if (cardItems.length > 2) {
    // Set first card expanded by default
    setExpanded(expandedIndex);
    
    console.log('Adding event listeners to card inners');
    cardInners.forEach((item, i) => {
      item.addEventListener('mouseenter', () => setExpanded(i));
      item.addEventListener('focusin', () => setExpanded(i));
    });
  }
});